// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2iECo","row":"ProcedureTreatmentSummary_row__1Ounb"};